import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import percentage from "../../../assets/icons/percentage.svg";
import InputWithIcon from "../../../components/InputWithIcon";
import Modal from "../../../components/Modal/Modal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
const initialData = {
  broker_representing_seller: "",
  brokerage_commission: "",
  broker_representing_buyer:"",
  gci_bds_seller:"",
  gci_bds_buyer:"",

};

const ExcecutedLoiConvert = ({  showModal, onClose, onCallApi, id   }) => {
  const [config] = useAuth();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState();
  const [formData, setFormData] = useState(initialData);


  const handleChange = (value, name) => {
    setError({ ...error, [name]: "" });
    setFormData({ ...formData, [name]: value });
  };

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
  };


  const handleUpdateStatus = (e) => {
    e.preventDefault();
    setDisable(true);

    const dataToSend = {
      brokerage_commission: formData?.brokerage_commission,
      broker_representing_seller: formData?.broker_representing_seller,
      broker_representing_buyer: formData?.broker_representing_buyer,
      gci_bds_seller: formData?.gci_bds_seller,
      gci_bds_buyer: formData?.gci_bds_buyer,
    };

    axios
      .post(`${BASE_URL}/convert-to-executed/${id}`, dataToSend, config)
      .then((res) => {
        onCallApi();
        onClose();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };
  
   useEffect(() => {
  if (showModal) {
    setFormData(initialData);
    setError({});
    setDisable(false);
  }
}, [showModal]);

  return (
    <Modal title={"Convert To Executed LOI"} desc={`Add the Executed LOI Property Information`} show={showModal} onClose={onClose}>
      <form onSubmit={handleUpdateStatus}>

        <div className="mt-6">
          <label className="dark-H head-4 mb-2 required:*:">
             GCI to Company <span className="red-D">*</span>
          </label>
          <InputWithIcon
            icon={percentage}
            className="body-N"
            name="contact"
            type="number"
            placeholder="Write Here"
            value={formData?.brokerage_commission}
            onChange={(e) => {
              handleChange(e.target.value, "brokerage_commission");
            }}
            onWheel={(e) => e.target.blur()}
          />
          {error?.brokerage_commission && <span className="body-S red-D">{error?.brokerage_commission}</span>}
        </div>

        {/* <div className="mt-6">
          <label className="dark-H head-4 mb-2 required:*:">
           GCI to Broker Representing Seller
          </label>
          <input
            className="body-N"
            name="contact"
            type="number"
            placeholder="Write Here"
            value={formData?.broker_representing_seller}
            onChange={(e) => {
              handleChange(e.target.value, "broker_representing_seller");
            }}
            onWheel={(e) => e.target.blur()}
          />
          {error?.broker_representing_seller && <span className="body-S red-D">{error?.broker_representing_seller}</span>}
        </div>

         <div className="mt-6">
          <label className="dark-H head-4 mb-2 required:*:">
            GCI to Broker Representing Buyer
          </label>
          <input
            className="body-N"
            name="contact"
            type="number"
            placeholder="Write Here"
            value={formData?.broker_representing_buyer}
            onChange={(e) => {
              handleChange(e.target.value, "broker_representing_buyer");
            }}
            onWheel={(e) => e.target.blur()}
          />
          {error?.broker_representing_buyer && <span className="body-S red-D">{error?.broker_representing_buyer}</span>}
        </div>

         <div className="mt-6">
          <label className="dark-H head-4 mb-2 required:*:">
           GCI to BDS (Seller)
          </label>
          <input
            className="body-N"
            name="contact"
            type="number"
            placeholder="Write Here"
            value={formData?.gci_bds_seller}
            onChange={(e) => {
              handleChange(e.target.value, "gci_bds_seller");
            }}
            onWheel={(e) => e.target.blur()}
          />
          {error?.gci_bds_seller && <span className="body-S red-D">{error?.gci_bds_seller}</span>}
        </div>

           <div className="mt-6">
          <label className="dark-H head-4 mb-2 required:*:">
            GCI to BDS (Buyer)
          </label>
          <input
            className="body-N"
            name="contact"
            type="number"
            placeholder="Write Here"
            value={formData?.gci_bds_buyer}
            onChange={(e) => {
              handleChange(e.target.value, "gci_bds_buyer");
            }}
            onWheel={(e) => e.target.blur()}
          />
          {error?.gci_bds_seller && <span className="body-S red-D">{error?.gci_bds_seller}</span>}
        </div> */}
       

        <div className="mt-7">
          <button type="submit" className="save-button light-L head-5 green-bg-H">
            Save
          </button>
          <button type="button" onClick={handleClose} className="green-H ml-5">
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ExcecutedLoiConvert;
